import React, { useRef } from "react";
import { useColorPalette } from "./hooks/useColorPalette";
import { ExlyInput } from "common/form";
import { useIsDesktop } from "features/Common/modules/Viewport/utils/Viewport.utils";
import { useDebounceAction } from "utils/hooks/useDebounceAction";
import { COLOR_PICKER_DEBOUNCE_MS } from "./ColorPalette.constants";

const COLOR_FIELDS = [
  { key: "template-primary-color", label: "Primary colour" },
  { key: "template-secondary-color", label: "Secondary colour" },
  { key: "template-page-background", label: "Page background colour" },
  { key: "template-primary-button-text-color", label: "Button text colour" },
];

export const ColorPalette = () => {
  const { colors, updateColor } = useColorPalette();
  const isDesktop = useIsDesktop();
  const inputRefs = useRef({});
  const debouncedUpdateColor = useDebounceAction(
    updateColor,
    COLOR_PICKER_DEBOUNCE_MS
  );

  const handleSwatchClick = (key) => {
    if (inputRefs.current[key]) {
      inputRefs.current[key].click();
    }
  };

  return (
    <div className={!isDesktop ? "tw-w-full" : "tw-w-[43%]"}>
      <div className="tw-flex tw-flex-col tw-gap-4">
        {COLOR_FIELDS.map(({ key, label }) => {
          const currentColor = colors[key] || "#000000";
          return (
            <div key={key} className="tw-flex tw-flex-col tw-gap-1.5">
              <label className="tw-text-sm tw-font-medium tw-text-[#272522]">
                {label}
              </label>
              <div className="tw-flex tw-items-center tw-gap-3">
                <div
                  onClick={() => handleSwatchClick(key)}
                  className="tw-w-10 tw-h-10 tw-min-w-[40px] tw-min-h-[40px] tw-rounded-md tw-border tw-border-solid tw-border-[#D1D5DB] tw-cursor-pointer tw-shadow-sm tw-relative tw-flex-shrink-0"
                  style={{ backgroundColor: currentColor }}
                  title="Click to pick color"
                >
                  <input
                    ref={(el) => (inputRefs.current[key] = el)}
                    type="color"
                    value={currentColor}
                    onChange={(e) =>
                      debouncedUpdateColor(key, e.target.value.toUpperCase())
                    }
                    className="tw-absolute tw-opacity-0 tw-w-0 tw-h-0 tw-pointer-events-none"
                  />
                </div>
                <div className="tw-flex-1">
                  <ExlyInput
                    value={currentColor}
                    onChange={(val) => updateColor(key, val)}
                    onBlur={(e) => {
                      let val = e.target.value.trim();
                      if (val && !val.startsWith("#")) val = `#${val}`;
                      updateColor(key, val.toUpperCase());
                    }}
                    placeholder="#000000"
                    fullWidth
                    inputClassName="tw-bg-white"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
